import type { Signature, SignatureGroup } from "../types/chain";

const SCAN_ID_RE = /^[A-Z]{3}-\d{3}$/;

const GROUP_BY_LABEL: Record<string, SignatureGroup> = {
  Wormhole: "wormhole",
  "Relic Site": "relic",
  "Data Site": "data",
  "Gas Site": "gas",
  "Combat Site": "combat",
  "Ore Site": "ore",
};

export function parseScannerClipboard(text: string): Signature[] | null {
  if (!text) return null;
  const lines = text.split(/\r?\n/).filter((l) => l.length > 0);
  if (lines.length === 0) return null;

  const out: Signature[] = [];
  for (const line of lines) {
    const fields = line.split("\t");
    if (fields.length !== 6) return null;
    const scanId = fields[0];
    if (!SCAN_ID_RE.test(scanId)) return null;
    const groupLabel = fields[2];
    const name = fields[3] ?? "";
    const group = GROUP_BY_LABEL[groupLabel] ?? "unknown";
    out.push({ scan_id: scanId, name, group });
  }
  return out;
}
